export const getColourPresentation = (colour) => {
  const normalizedColour = String(colour || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ");

  if (!normalizedColour) return null;

  const finishMap = [
    {
      match: ["metallic bronze", "bronze metallic"],
      swatchStyle: {
        background: "linear-gradient(135deg, #6f4e37 0%, #b87333 100%)",
        borderColor: "#8b5e3c",
      },
      badgeStyle: {
        background: "#fbf4ed",
        borderColor: "#d2ad87",
        color: "#8b5e3c",
      },
    },
    {
      match: ["black silver", "silver black"],
      swatchStyle: {
        background: "linear-gradient(135deg, #111827 0%, #9ca3af 100%)",
        borderColor: "#6b7280",
      },
      badgeStyle: {
        background: "#f8fafc",
        borderColor: "#cbd5e1",
        color: "#475569",
      },
    },
    {
      match: ["stainless steel"],
      swatchStyle: {
        background: "linear-gradient(135deg, #d1d5db 0%, #9ca3af 50%, #e5e7eb 100%)",
        borderColor: "#9ca3af",
      },
      badgeStyle: {
        background: "#f8fafc",
        borderColor: "#cbd5e1",
        color: "#6b7280",
      },
    },
    {
      match: ["matt black", "matte black"],
      swatchStyle: {
        backgroundColor: "#1f2937",
        borderColor: "#1f2937",
      },
      badgeStyle: {
        background: "#f8fafc",
        borderColor: "#cbd5e1",
        color: "#1f2937",
      },
    },
    {
      match: ["flat white"],
      swatchStyle: {
        backgroundColor: "#f9fafb",
        borderColor: "#d1d5db",
      },
      badgeStyle: {
        background: "#fcfcfd",
        borderColor: "#d1d5db",
        color: "#6b7280",
      },
    },
    {
      match: ["dark timber"],
      swatchStyle: {
        backgroundColor: "#6b4423",
        borderColor: "#6b4423",
      },
      badgeStyle: {
        background: "#fbf5ef",
        borderColor: "#d6b496",
        color: "#6b4423",
      },
    },
    {
      match: ["light timber"],
      swatchStyle: {
        backgroundColor: "#c19a6b",
        borderColor: "#c19a6b",
      },
      badgeStyle: {
        background: "#fcf7ee",
        borderColor: "#e8d2ae",
        color: "#a16207",
      },
    },
    {
      match: ["gun metal", "gunmetal"],
      swatchStyle: {
        backgroundColor: "#4b5563",
        borderColor: "#4b5563",
      },
      badgeStyle: {
        background: "#f8fafc",
        borderColor: "#cbd5e1",
        color: "#4b5563",
      },
    },
    {
      match: ["rose gold"],
      swatchStyle: {
        background: "linear-gradient(135deg, #b76e79 0%, #e0bfb8 100%)",
        borderColor: "#b76e79",
      },
      badgeStyle: {
        background: "#fff5f7",
        borderColor: "#e3b3bd",
        color: "#9d5563",
      },
    },
    {
      match: ["sand"],
      swatchStyle: {
        backgroundColor: "#d6c6a5",
        borderColor: "#d6c6a5",
      },
      badgeStyle: {
        background: "#f5efe4",
        borderColor: "#d6c6a5",
        color: "#8a6a2f",
      },
    },
    {
      match: ["cream magnolia", "magnolia cream"],
      swatchStyle: {
        backgroundColor: "#f3e7cf",
        borderColor: "#e7d7b7",
      },
      badgeStyle: {
        background: "#fcf7ee",
        borderColor: "#e7d7b7",
        color: "#8b7355",
      },
    },
    {
      match: ["light pink", "soft pink", "baby pink"],
      swatchStyle: {
        backgroundColor: "#f7b6cb",
        borderColor: "#e88cb0",
      },
      badgeStyle: {
        background: "#fff0f5",
        borderColor: "#e9a8c4",
        color: "#a43e6b",
      },
    },
    {
      match: ["lavender"],
      swatchStyle: {
        backgroundColor: "#c4b5fd",
        borderColor: "#a78bfa",
      },
      badgeStyle: {
        background: "#f5f3ff",
        borderColor: "#c4b5fd",
        color: "#7c3aed",
      },
    },
  ];

  const matchedFinish = finishMap.find(({ match }) =>
    match.some((candidate) => normalizedColour.includes(candidate)),
  );

  if (matchedFinish) return matchedFinish;

  const tokenMap = {
    black: "#111827",
    white: "#ffffff",
    blue: "#2563eb",
    red: "#dc2626",
    green: "#16a34a",
    yellow: "#eab308",
    orange: "#f97316",
    purple: "#9333ea",
    pink: "#ec4899",
    lavender: "#a78bfa",
    brown: "#8b5e3c",
    bronze: "#b87333",
    cream: "#f3e7cf",
    magnolia: "#efe2c4",
    beige: "#e8d7b3",
    ivory: "#f8f4e8",
    grey: "#6b7280",
    gray: "#6b7280",
    silver: "#9ca3af",
    gold: "#d4a017",
    rose: "#b76e79",
    steel: "#94a3b8",
    stainless: "#cbd5e1",
    timber: "#8b5e3c",
    wood: "#8b5e3c",
    sand: "#d6c6a5",
  };

  const matchedColours = normalizedColour
    .split(" ")
    .map((token) => tokenMap[token])
    .filter(Boolean);

  if (matchedColours.length === 0) {
    return {
      badgeStyle: {
        background: "#f8fafc",
        borderColor: "#dbe3ee",
        color: "#475569",
      },
    };
  }

  const primaryColour = matchedColours[0];
  const needsSoftBg = ["#ffffff", "#f3e7cf", "#efe2c4", "#e8d7b3", "#d6c6a5", "#eab308"].includes(primaryColour);

  return {
    swatchStyle: {
      background:
        matchedColours.length === 1
          ? primaryColour
          : `linear-gradient(135deg, ${matchedColours.join(", ")})`,
      borderColor: needsSoftBg ? "#d1d5db" : primaryColour,
    },
    badgeStyle: {
      background: needsSoftBg ? "#fcfaf5" : "#f8fafc",
      borderColor: needsSoftBg ? "#e7d7b7" : `${primaryColour}33`,
      color: primaryColour === "#ffffff" ? "#475569" : primaryColour,
    },
  };
};
